'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { useTranslation } from '@/app/i18n/client'
import Link from 'next/link'

const PrePostHarvestNavBar = () => {
  const { t } = useTranslation()
  const [activeComponent, setActiveComponent] = useState<string>('')
  const pathName = usePathname()
  useEffect(() => {
    setActiveComponent(pathName.split('/').pop() || '')
  }, [pathName])
  return (
    <div className="flex justify-center items-center relative h-[62px] mobile:top-2">
      {/* Background */}
      <span className="absolute bg-[#f5f5f5] h-[62px] w-screen top-0 z-0"></span>
      {/* Nav Items */}
      <div className="w-[1280px] mobile-width mobile:overflow-x-auto">
        <div className="flex text-[14px] select-none w-full justify-between items-center z-10">
          {/* Left Navbar */}
          <div className="flex translate-x-[330px] font-ns_semibold mobile:translate-x-0">
            <ul className="flex gap-[40px] items-center  mobile:gap-[25px] mobile:justify-center">
              <li
                onClick={() => setActiveComponent('profile')}
                className={
                  activeComponent === 'profile'
                    ? 'cursor-pointer text-orange mobile:text-nowrap'
                    : 'cursor-pointer mobile:text-nowrap'
                }
              >
                <Link href={`profile`}>{t('Profile')}</Link>{' '}
              </li>

              <li
                onClick={() => setActiveComponent('product-services')}
                className={
                  activeComponent === 'product-services'
                    ? 'cursor-pointer text-[#df7d2f] mobile:text-nowrap'
                    : 'cursor-pointer mobile:text-nowrap'
                }
              >
                <Link href={`product-services`}>{t('Products/Services')}</Link>{' '}
              </li>

              <li
                onClick={() => setActiveComponent('news')}
                className={
                  activeComponent === 'news'
                    ? 'cursor-pointer text-[#df7d2f] mobile:text-nowrap'
                    : 'cursor-pointer mobile:text-nowrap'
                }
              >
                <Link href={`news`}>{t('News')}</Link>{' '}
              </li>

              <li
                onClick={() => setActiveComponent('contact-us')}
                className={
                  activeComponent === 'contact-us'
                    ? 'cursor-pointer text-[#df7d2f] mobile:text-nowrap'
                    : 'cursor-pointer mobile:text-nowrap'
                }
              >
                <Link href={`contact-us`}>{t('Contact Us')}</Link>{' '}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrePostHarvestNavBar
